<template>
  <div class="pipeline-create-sandbox-environment">
    <FlySwitch
      label="Use sandbox environment"
      name="use_sandbox_environment"
      :checked="usesSandbox"
      @change="onUseSandboxChange"
    />
  </div>
</template>

<script>
import FlySwitch from 'shared/components/Form/FlySwitch.vue';
import FormStoreMixin from 'shared/stores/form/FormStoreMixin';

export default {
  name: 'PipelineCreateSandboxEnvironment',
  components: {
    FlySwitch,
  },
  mixins: [FormStoreMixin()],
  data() {
    return {
      // eslint-disable-next-line vue/no-unused-properties
      fileReader: null,
    };
  },
  computed: {
    isSandbox() {
      return this.formFieldValue('config.tap_config.environment') === 'Sandbox';
    },
    usesSandbox() {
      return this.isSandbox;
    },
  },
  methods: {
    onUseSandboxChange(e) {
      this.setFormFieldAtPath(
        'config.tap_config.environment',
        e.target.checked ? 'Sandbox' : 'Production',
      );
    },
  },
};
</script>

<style lang="scss">
.pipeline-create-sandbox-environment {
  .fly-switch {
    padding: 16px 0;

    .fly-switch--label-text {
      font-size: 20px;
      line-height: 28px;
      font-family: 'Source Sans Pro', sans-serif;
    }
  }
}
</style>
